

import { useRef, useState } from "react";
import { Grid, TextField } from "@mui/material";
import { AutocompleteConLoading } from "../../components";
import { HeaderDeCheckout } from "../../layouts";
import { useUsuariosStore } from "../../../stores";
import { listadoUsuariosVenta, startEditarDesdeVenta } from "../../../services";
import { BotonesAndCargando } from "../../components/botones";





export const CheckoutScreen = () => {
    // const { view } = useSelector( state => state.iva );

    const debounceRef = useRef(null);
    const { activarUserVenta, usuarioVenta } = useUsuariosStore();
    const [cargando, setCargando] = useState(false);
    const [optiones, setOpciones] = useState(usuarioVenta ? [usuarioVenta] : []);
    const [usuario, setUsuario] = useState(usuarioVenta);



    const buscarUsuario = (texto) => {
        if(debounceRef.current){ clearTimeout(debounceRef.current); }
        debounceRef.current = setTimeout(async () => {
            const query = texto.trim();
            if (query.length === 0) return;

            setCargando(true);
            const respuesta = await listadoUsuariosVenta(texto);
            setOpciones(respuesta)
            setCargando(false);
        }, 700);
    };



    const handleActivarUser = (user) => {
        if( !user ) return;
        setUsuario(user);
    }



    const onChange = (e) => {
        const { name, value } = e.target;
        setUsuario((prev) => ({ ...prev, [name]: value }));
    };



    const handleGenerarCheckout = (e) => {
        e.preventDefault();
        if(!usuario) return;

        startEditarDesdeVenta(usuario);
        activarUserVenta(usuario);
    };




    return (

        <HeaderDeCheckout titulo={'Completar Pedido'}>
            <form style={{width:'100%'}} onSubmit={ handleGenerarCheckout }>
                <Grid container spacing={3} sx={{mt:2}}>

                    <Grid item xs={12} sm={6}>
                        <AutocompleteConLoading
                            label="Usuario Venta" 
                            placeholder='Usuario Venta' 
                            fullWidth
                            name="usuario"
                            options={optiones}
                            value={usuario ?? null}
                            loading={cargando}
                            handleFunction={ (value) => buscarUsuario(value) }
                            onChange={ handleActivarUser }
                        />
                    </Grid>

                    {(usuario) &&
                    <>
                    <Grid item xs={12} sm={6}>
                        <TextField required
                            variant="filled"
                            label='Cedula'
                            type='text'
                            placeholder='Cedula'
                            fullWidth
                            name="cedula"
                            value={ usuario.cedula }
                            onChange={ onChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField required
                            variant="filled"
                            label='Ciudad'
                            type='text'
                            placeholder='Ciudad'
                            fullWidth
                            name="ciudad"
                            value={ usuario.ciudad }
                            onChange={ onChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField required
                            variant="filled"
                            label='Dirección'
                            type='text'
                            placeholder='Dirección'
                            fullWidth
                            name="direccion"
                            value={ usuario.direccion }
                            onChange={ onChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="filled"
                            label='Dirección 2'
                            type='text'
                            placeholder='Dirección 2'
                            fullWidth
                            name="direccion2"
                            value={ usuario.direccion2 || '' }
                            onChange={ onChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField required
                            variant="filled"
                            label='Movil'
                            type='number'
                            placeholder='Movil'
                            fullWidth
                            name="movil"
                            value={ usuario.movil }
                            onChange={ onChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField required
                            variant="filled"
                            disabled
                            label='Rol'
                            type='text'
                            placeholder='Rol'
                            fullWidth
                            name="rol"
                            value={ usuario.role }
                            onChange={ onChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="filled"
                            disabled
                            label='Distribuidor'
                            type='text'
                            placeholder='Distribuidor'
                            fullWidth
                            name="distribuidor"
                            value={ (usuario?.distribuidor) ? usuario?.distribuidor.nombre : 'No-Aplica' }
                            onChange={ onChange } 
                        />
                    </Grid>
                    </>
                    }
                </Grid>

                {( usuario ) &&
                <Grid container sx={{mb:2, mt:7, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Validar Datos'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>
                }
            </form>
            
        </HeaderDeCheckout>
        


        // <>

        //   <>
        //     {
        //       (usuario.role === 'SUPERADMIN' || usuario.role === 'ADMIN') && (
        //         <>
        //           {
        //             viewsAdmin(view)
        //           }
        //         </>
        //       )
        //     }
        //   </>

        //   <>
        //     {
        //       ( usuario.role === 'DISTRIBUIDOR' ) && (
        //         <>
        //           {
        //             ( view === 'cliente' ) && 
        //             <ClienteCheckoutPorDistri />
        //           }

        //           {
        //             ( view === 'distri' ) && 
        //             <DistriPropioCheckout />
        //           }
        //         </>
        //       )
        //     }
        //   </>

        //   <>
        //     {
        //       (usuario.role === 'PUBLICISTA') && 
        //         <DistriPropioCheckout />
        //     }
        //   </>

        //   <>
        //     {
        //       (usuario.role === 'EMPRESA') && 
        //         <DistriPropioCheckout />
        //     }
        //   </>

        
        
        // </>


        


    
    )

}
